import routes from './route-constants';
import accountConstants from './account-constants';

const { statuses, loginStates } = accountConstants;

var menus = {};

menus.MAIN = [
    {
        text: 'Home',
        path: routes.VERIFY,
        auth: {
            loginState: loginStates.LOGGED_IN,
            approvalStatus: statuses.UNSUBMITTED
        }
    },
    {
        text: 'Home',
        path: routes.SUBMITTED,
        auth: {
            loginState: loginStates.LOGGED_IN,
            approvalStatus: statuses.SUBMITTED
        }
    },
    {
        text: 'Home',
        path: routes.DENIED,
        auth: {
            loginState: loginStates.LOGGED_IN,
            approvalStatus: statuses.DENIED
        }
    },
    {
        text: 'Home',
        path: routes.LOGIN,
        auth: {
            loginState: loginStates.LOGGED_OUT
        }
    },{
        text: 'Home',
        path: routes.HOME,
        auth: {
            loginState: loginStates.LOGGED_IN,
            approvalStatus: statuses.APPROVED
        }
    },{
        text: 'Analytical Test Descriptions',
        path: routes.TEST_DESCRIPTIONS
    },{
        text: 'Sampling Guidelines',
        path: routes.SAMPLING_GUIDELINES
    },{
        text: 'Flushing/Converting Procedure',
        path: routes.FLUSHING_CONVERTING_PROCEDURE
    },{
        text: 'FAQ',
        path: routes.FAQ
    },{
        text: 'Contact Us',
        path: routes.CONTACT
    }
]

menus.LOGIN = [
    {
        text: 'Log In',
        path: routes.LOGIN
    },
    {
        text: 'Create Account',
        path: routes.REGISTER
    }
]

menus.ADMIN_USERS = {
    PENDING: 'PENDING',
    REGISTERED: 'REGISTERED',
    REVOKED: 'REVOKED'
}

export default menus;



// WEBPACK FOOTER //
// ./web-app/constants/menus.js